"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElevatedSnackBar = void 0;
const react_1 = __importStar(require("react"));
const colors_1 = require("../../../../theme/colors");
const icons_1 = require("../../../../theme/icons");
const ElevatedSnackBar_styles_1 = require("./ElevatedSnackBar.styles");
const ElevatedSnackBar = ({ message, duration, actionLabel, id, actionParams, actionClick, onClose, secondaryText, error, }) => {
    (0, react_1.useEffect)(() => {
        const timer = setTimeout(() => {
            if (onClose) {
                onClose(id);
            }
        }, duration);
        return () => {
            clearTimeout(timer);
        };
    }, [duration, id, onClose]);
    return (react_1.default.createElement(ElevatedSnackBar_styles_1.ElevatedSnackbarWrapper, { "$error": !!error },
        react_1.default.createElement(ElevatedSnackBar_styles_1.CrossWrapper, { onClick: () => onClose && onClose(id) }, onClose !== undefined && react_1.default.createElement(icons_1.Close, { color: colors_1.WHITE })),
        react_1.default.createElement(ElevatedSnackBar_styles_1.MessageWrapper, { closeEvent: onClose },
            react_1.default.createElement(ElevatedSnackBar_styles_1.Wrapper, null,
                react_1.default.createElement(ElevatedSnackBar_styles_1.Message, { "$error": !!error }, message),
                react_1.default.createElement(ElevatedSnackBar_styles_1.SecondaryMessage, { "$error": !!error }, secondaryText)),
            actionLabel && (react_1.default.createElement(ElevatedSnackBar_styles_1.ActionWrapper, null,
                react_1.default.createElement(ElevatedSnackBar_styles_1.Separator, null, "|"),
                react_1.default.createElement(ElevatedSnackBar_styles_1.Action, { onClick: () => {
                        if (actionClick) {
                            actionClick(actionParams);
                        }
                        if (onClose) {
                            onClose(id);
                        }
                    } }, actionLabel))))));
};
exports.ElevatedSnackBar = ElevatedSnackBar;
//# sourceMappingURL=ElevatedSnackBar.js.map